import React, { useEffect, useState } from "react";
import HomeNav from "./HomeNav";
import HomeReports from "./HomeReports";
import styles from "./Home.module.css";
import CreateReportModal from "./modal/CreateReportModal";
import ReportConfirmModal from "./modal/ReportConfirmModal";
import { AddressSearchResult, homeApis } from "../../apis/homeApis";
import Loader from "../../components/custom-loader/Loader";
import { useNavigate } from "react-router-dom";
import ConfirmLogoutModal from "../../components/confirm-modal/ConfirmLogoutModal";
import { authApis } from "../../apis/authApis";

const Home: React.FC = () => {
  const navigate = useNavigate();

  const [logoutOpen, setLogoutOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const [location, setLocation] = useState<{
    lat: number;
    lng: number;
    address?: string;
    city?: string;
    addressDetails: AddressSearchResult;
  } | null>(null);

  const handleLogout = async () => {
    const res = await authApis.logout();
    console.log("res", res);

    if (res?.success) {
      localStorage.removeItem("LVaccessToken");
      localStorage.removeItem("LVoktaAuth");
      localStorage.removeItem("LVFname");
      localStorage.removeItem("LVuser");

      navigate("/login", { replace: true });
    }
  };

  const handleConfirm = (selectedLocation: {
    lat: number;
    lng: number;
    address?: string;
    city?: string;
    addressDetails: AddressSearchResult;
  }) => {
    setLocation(selectedLocation);
    setConfirmOpen(false);
    setTimeout(() => setReportOpen(true), 200);
  };

  const fetchReports = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("LVuser") || "{}");
      const res = await homeApis.getInspectorReports(user.id);
      setReports(res.data.reports || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <div className={styles.homePage}>
      <HomeNav onOpenLogoutModal={() => setLogoutOpen(true)} />

      <div className={styles.homeContent}>
        <button
          className={styles.newReportButton}
          onClick={() => setConfirmOpen(true)}
        >
          + Create New Report
        </button>

        <h3 className={styles.reportHeading}>
          Reports Submitted ({reports.length})
        </h3>

        {loading ? <Loader /> : <HomeReports reports={reports} />}
      </div>

      <ReportConfirmModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      />

      <CreateReportModal
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        coords={location}
        selectedAddress={location?.address}
        selectedCity={location?.city}
        selectedAddressDetails={location?.addressDetails}
        refreshReports={fetchReports}
      />

      <ConfirmLogoutModal
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        onLogout={handleLogout}
      />
    </div>
  );
};

export default Home;
